import { render, staticRenderFns } from "./MRStatusFilter.vue?vue&type=template&id=a0ffd7f4&scoped=true"
import script from "./MRStatusFilter.vue?vue&type=script&lang=ts"
export * from "./MRStatusFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ffd7f4",
  null
  
)

export default component.exports